import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { handleSafeAppTransaction } from 'modules/api/methods/handleSafeAppTransaction';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';

import { stake } from '../methods/stake';

interface IStakeArgs {
  amount: BigNumber;
}

export const { useStakeMutation } = api.injectEndpoints({
  endpoints: build => ({
    stake: build.mutation<Address, IStakeArgs>({
      queryFn: queryFnNotifyWrapper<IStakeArgs, void, Address>(
        async ({ amount }, { dispatch }) => {
          const walletClient = getWalletClient();
          const publicClient = getPublicClient();

          const txPromise = stake(walletClient, {
            amount,
          });

          const hash = await handleSafeAppTransaction({
            txPromise,
            dispatch,
            publicClient,
            accountAddress: asAddress(walletClient.account?.address),
          });

          return {
            data: hash || '0x',
          };
        },
      ),
      invalidatesTags: [
        cacheTags.account,
        cacheTags.liquidStaking,
        cacheTags.allowance,
      ],
    }),
  }),
});
